import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../CommonComponents/CommonCardHeader/CommonCardHeader";
import AttachmentsTable from "../DataTables/Candidates/AttachmentsTable";

//MODALS
import UploadAttachments from "../UiKits/Modal/Applicants/UploadAttachments";

interface CandidateProfileProps {
  ApplNo: string;
}

const Attachment: React.FC<CandidateProfileProps> = ({ ApplNo }) => {
  return (
    <Col sm="12">
      <Card className="card-absolute">
        <CommonCardHeader
          headClass="bg-primary"
          tagClass="txt-light"
          icon={<i className="icofont icofont-clip me-1"></i>}
          title={"Attachments"}
        />
        <CardBody>
          <UploadAttachments ApplNo={ApplNo} />
          <AttachmentsTable ApplNo={ApplNo} />
        </CardBody>
      </Card>
    </Col>
  );
};
export default Attachment;
